import React, { useState } from 'react';
import { ActionDialog, Dialog } from '@shared/components';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import useStyle from './style';
import clsx from 'clsx';

const noop = () => {};

const defaultState = {
  isAutofixOpen: false,
  confirmAutofix: false,
};

const DuplicateDialog = ({
  open = false,
  heading = '',
  subHeading = '',
  content = '',
  autofixTooltip = '',
  manualUpdateTooltip = '',
  isFetchingUserRoles = false,
  onAutofix = noop,
  onManualUpdate = noop,
  onClose = noop,
}) => {
  const classes = useStyle();
  const [state, setState] = useState(defaultState);

  const renderAutoFixConfirmation = () => {
    return (
      <div>
        <Typography variant='h6'>Auto Fix</Typography>
        <Typography variant='body1' className='mt-5 mb-3'>
          This action will automatically take the current extension number and
          add that number in front of the @ symbol in the email address.
        </Typography>
        <FormControlLabel
          value={state.confirmAutofix}
          control={
            <Checkbox
              color='primary'
              onChange={evt => {
                const { checked } = evt.target;
                setState(prevState => ({
                  ...prevState,
                  confirmAutofix: checked,
                }));
              }}
            />
          }
          label={<Typography variant='body2'>I understand</Typography>}
        />
      </div>
    );
  };

  const handleClose = () => {
    setState(prevState => ({
      ...prevState,
      ...defaultState,
    }));
    onClose();
  };

  const handelAutoFixConfimationClose = () => {
    setState(prevState => ({
      ...prevState,
      isAutofixOpen: defaultState.isAutofixOpen,
      confirmAutofix: defaultState.confirmAutofix,
    }));
  };

  return (
    <>
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        open={open}
        onClose={handleClose}
        classes={{
          paper: classes.duplicateDialog,
        }}
      >
        <Dialog.Title hasClose>
          <Typography variant='h6'>{heading}</Typography>
        </Dialog.Title>
        <Dialog.Content>
          <Typography variant='body2' className='mb-4' color='error'>
            {subHeading}
          </Typography>
          <Typography variant='body1'>{content}</Typography>
        </Dialog.Content>
        <Dialog.Actions>
          <div className='d-flex f-align-center f-justify-between p-5 w-100'>
            <Button variant='outlined' onClick={handleClose}>
              Ignore
            </Button>
            <div className='d-flex f-align-center'>
              <Tooltip title={autofixTooltip} placement='top'>
                <Button
                  variant='outlined'
                  color='primary'
                  onClick={() => {
                    setState(prevState => ({
                      ...prevState,
                      isAutofixOpen: true,
                    }));
                  }}
                >
                  Auto Fix
                </Button>
              </Tooltip>
              <Tooltip title={manualUpdateTooltip} placement='top'>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={onManualUpdate}
                  className='ml-5'
                >
                  Manual Update
                </Button>
              </Tooltip>
            </div>
          </div>
        </Dialog.Actions>
      </Dialog>
      {state.isAutofixOpen && (
        <ActionDialog
          open={state.isAutofixOpen}
          positiveActionLabel='Update'
          negativeActionLabel='Cancel'
          isConfirmDisabled={!state.confirmAutofix}
          content={renderAutoFixConfirmation()}
          onConfirm={onAutofix}
          onCancel={handelAutoFixConfimationClose}
          onClose={handelAutoFixConfimationClose}
          isLoading={isFetchingUserRoles}
          classes={{
            paper: classes.autoFixDialog,
            confirm: clsx({ 'color-white bg-primary': state.confirmAutofix }),
          }}
        />
      )}
    </>
  );
};

export default DuplicateDialog;
